import { styled } from '@mui/material/styles';
export const Background = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.black10.main,
}));
export const Wrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    padding: theme.spacing(10, 0),
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(7.5, 0),
    },
}));
export const Content = styled('div')(({ theme }) => ({
    display: 'flex',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
    },
}));
export const Icon = styled('img')(({ theme }) => ({
    maxWidth: '80px',
    maxHeight: '80px',
    marginRight: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
}));
export const TextWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 0.8,
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
        flex: 1,
        textAlign: 'center',
    },
}));
export const Heading = styled('span')(({ theme }) => ({
    marginBottom: theme.spacing(2.5),
    fontWeight: 700,
}));
export const ImagesWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    '& > a:first-child': {
        marginRight: 0,
    },
    '& > a': {
        fontSize: 0,
    },
    '& > a:last-child svg': {
        width: '135px',
        height: '45px',
        marginTop: theme.spacing(1),
    },
    [theme.breakpoints.up('lg')]: {
        marginLeft: 'auto',
        '& > a:last-child svg': {
            height: '41.5px',
            marginTop: theme.spacing(0.5),
            marginLeft: '-5px',
        },
    },
    [theme.breakpoints.down('md')]: {
        margin: theme.spacing(5, 'auto', 'auto'),
        '& > a:first-child': {
            marginRight: 0,
            marginBottom: 0,
        },
    },
}));
//# sourceMappingURL=styles.js.map